
 /**
     * @author luxiaolin
     * @description 汉字按拼音 中文排序
     * @param {*} arr
     * @param {*} dataLeven
     */
export function sortChinese(arr, dataLeven) {
  /* 获取数组元素内需要比较的值 */
  function getValue (option) { // 参数： option 数组元素
    if (!dataLeven) return option
    var data = option
    dataLeven.split('.').filter(function (item) {
      data = data[item]
    })
    return data + ''
  }
  arr.sort(function (item1, item2) {
    return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
  })
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js